import React__default from 'react';
import PT from 'prop-types';
import styled from 'styled-components';

const TouchLinkGroupItem = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-30078624__sc-13ge4n6-0"
})(["border-radius:0px;border-bottom:1px solid ", ";list-style:none;margin:0;word-wrap:break-word;> a{border-radius:0px;}:first-of-type,:first-of-type > a{border-radius:", " ", " 0 0;}:last-of-type,:last-of-type > a{border-bottom:none;border-radius:0 0 ", " ", ";}"], ({
  theme
}) => theme.touchLink.borderColor, ({
  theme
}) => theme.touchLink.borderRadius, ({
  theme
}) => theme.touchLink.borderRadius, ({
  theme
}) => theme.touchLink.borderRadius, ({
  theme
}) => theme.touchLink.borderRadius);
const TouchLinkGroupComponent = ({
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement("ul", rest, children && React__default.Children.map(children, child => {
  if (! /*#__PURE__*/React__default.isValidElement(child)) return null;
  return /*#__PURE__*/React__default.createElement(TouchLinkGroupItem, null, /*#__PURE__*/React__default.cloneElement(child, {
    ...child.props
  }));
}));
const TouchLinkGroup = /*#__PURE__*/styled(TouchLinkGroupComponent).withConfig({
  componentId: "sc-storm-ui-30078624__sc-13ge4n6-1"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";display:block;list-style-type:none;margin-left:0;padding:0;position:relative;margin-block-start:unset;margin-block-end:unset;margin-inline-start:unset;margin-inline-end:unset;padding-inline-start:unset;"], ({
  theme
}) => theme.touchLink.backgroundColor, ({
  theme
}) => theme.touchLink.group.borderColor, ({
  theme
}) => theme.touchLink.borderRadius);
TouchLinkGroup.displayName = 'TouchLinkGroup';
TouchLinkGroup.propTypes = {
  /**
   * The React nodes that are rendered by the TouchLinkGroup.
   */
  children: PT.node
};

export { TouchLinkGroup as T };
//# sourceMappingURL=TouchLinkGroup-CgXJK_C8.js.map
